// Apolo IDE — Plan tab block kinds registry (sprint plan-tab-v1, E2/E3).
//
// Each block kind defines: human label, lucide icon name, default size,
// default payload, accent color. Used by the create-block menu, sidebar
// palette, and renderers in E3.

export const BLOCK_KINDS = {
  text: {
    label: 'Texto',
    icon: 'Type',
    color: '#8b5cf6',
    defaults: { w: 360, h: 180, payload: { body: '' } },
    description: 'Bloco de markdown editável',
  },
  sticky: {
    label: 'Sticky',
    icon: 'StickyNote',
    color: '#facc15',
    defaults: { w: 240, h: 200, payload: { body: '' } },
    description: 'Nota amarela, sem formatação',
  },
  heading: {
    label: 'Título',
    icon: 'Heading1',
    color: '#a855f7',
    defaults: { w: 480, h: 80, payload: { text: 'Novo título', level: 1 } },
    description: 'Headline pra agrupar seções do canvas',
  },
  todo: {
    label: 'To-do',
    icon: 'CheckSquare',
    color: '#06b6d4',
    defaults: { w: 320, h: 220, payload: { items: [] } },
    description: 'Lista de tarefas com checkbox',
  },
  image: {
    label: 'Imagem',
    icon: 'Image',
    color: '#ec4899',
    defaults: { w: 360, h: 240, payload: { url: '', alt: '' } },
    description: 'Imagem via URL ou upload',
  },
  video: {
    label: 'Vídeo',
    icon: 'Video',
    color: '#f97316',
    defaults: { w: 480, h: 300, payload: { url: '', autoplay: false } },
    description: 'YouTube, Vimeo, Loom ou MP4 direto',
  },
  link: {
    label: 'Link',
    icon: 'Link2',
    color: '#0ea5e9',
    defaults: { w: 320, h: 120, payload: { url: '', title: '', description: '' } },
    description: 'Link com preview',
  },
  file: {
    label: 'Arquivo',
    icon: 'FileText',
    color: '#10b981',
    defaults: { w: 320, h: 140, payload: { file_id: null, name: '' } },
    description: 'Referência a um plan_file (md ou pdf)',
  },
  pdf: {
    label: 'PDF',
    icon: 'FileType',
    color: '#dc2626',
    defaults: { w: 420, h: 540, payload: { file_id: null, name: '' } },
    description: 'PDF inline com preview (drag-drop ou upload)',
  },
  skill: {
    label: 'Skill',
    icon: 'Sparkles',
    color: '#a78bfa',
    defaults: { w: 320, h: 160, payload: { skill_name: '', version: 'latest', notes: '' } },
    description: 'Bloco que invoca uma skill na sprint exportada',
  },
  divider: {
    label: 'Divisor',
    icon: 'Minus',
    color: '#737373',
    defaults: { w: 360, h: 24, payload: { label: '' } },
    description: 'Separador visual entre seções',
  },
  mermaid: {
    label: 'Diagrama',
    icon: 'GitBranch',
    color: '#22c55e',
    defaults: { w: 480, h: 280, payload: { source: 'graph TD;\n  A-->B;' } },
    description: 'Diagrama Mermaid renderizado',
  },
  table: {
    label: 'Tabela',
    icon: 'Table2',
    color: '#3b82f6',
    defaults: { w: 480, h: 240, payload: { rows: [['', '']], headers: ['Coluna A', 'Coluna B'] } },
    description: 'Tabela simples editável',
  },
  'chat-ref': {
    label: 'Conversa',
    icon: 'MessageSquare',
    color: '#6366f1',
    defaults: { w: 320, h: 200, payload: { conversation_id: null, snippet: '' } },
    description: 'Referência a uma conversa do chat copiloto',
  },
  embed: {
    label: 'Embed',
    icon: 'Code2',
    color: '#0891b2',
    defaults: { w: 480, h: 320, payload: { html: '' } },
    description: 'HTML embed (iframe, twitter, etc) — sandbox sempre',
  },
  chart: {
    label: 'Gráfico',
    icon: 'BarChart3',
    color: '#06b6d4',
    defaults: { w: 420, h: 300, payload: { type: 'line', title: '', series: [{ name: 'Série', data: [] }], source: 'manual' } },
    description: 'Linha/barra/área/pizza — dados manuais ou preset do plano',
  },
};

export const BLOCK_KIND_ORDER = [
  'text', 'sticky', 'heading', 'todo',
  'image', 'video', 'link', 'file', 'pdf',
  'skill', 'chart', 'mermaid', 'table',
  'chat-ref', 'embed', 'divider',
];

export function getBlockKindMeta(kind) {
  return BLOCK_KINDS[kind] || BLOCK_KINDS.text;
}
